import { render, staticRenderFns } from "./HangUpIcon.vue?vue&type=template&id=64e3b462&"
import script from "./HangUpIcon.vue?vue&type=script&lang=js&"
export * from "./HangUpIcon.vue?vue&type=script&lang=js&"
import style0 from "./HangUpIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports